import axios from "axios";
import { API_BASE_URL } from "../apiClient";

const base = `${API_BASE_URL}/api/admin/goat-labour`;
const headers = () => {
  const token = localStorage.getItem("authToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
};
const request = (method, path = "", data, params) =>
  axios({ method, url: `${base}${path}`, data, params, headers: headers() }).then((res) => res.data);

export const goatLabourService = {
  list: (params = {}) => request("get", "", undefined, params),
  batches: () => request("get", "/batches"),
  get: (id) => request("get", `/${id}`),
  create: (data) => request("post", "", data),
  update: (id, data) => request("put", `/${id}`, data),
  deactivate: (id) => request("delete", `/${id}`),
  attendance: (date) => request("get", "/attendance", undefined, { date }),
  mark: (id, date, status, notes = "") => request("put", `/${id}/attendance/${date}`, { status, notes }),
  unmark: (id, date) => request("delete", `/${id}/attendance/${date}`),
  history: (id, from, to) => request("get", `/${id}/attendance`, undefined, { from, to }),
  summary: (from, to) => request("get", "/summary", undefined, { from, to }),
};

export const goatLabourApiError = (error) =>
  error?.response?.data?.message || (error?.response?.status === 403 ? "Administrator permission is required." :
    error?.message || "The request failed. Please try again.");
